import React from "react";

type Props = {
  showCassol: boolean;
};

function TableHeader({ showCassol }: Props) {
  if (showCassol) {
    return (
      <tr>
        <th>Simulation</th>
        <th>Simulation Time</th>
        <th>Average Distance Walked</th>
        <th>Average Velocity</th>
        <th>Average Density</th>
        <th>Average Time</th>
        <th>ф</th>
        <th>ξ</th>
      </tr>
    );
  } else {
    return (
      <tr>
        <th>Simulation</th>
        <th>Simulation Time</th>
        <th>Average Distance Walked</th>
        <th>Average Velocity</th>
        <th>Average Density</th>
        <th>Average Time</th>
      </tr>
    );
  }
}

export default TableHeader;
